export class LoadingScreen {
  private overlay: HTMLDivElement;
  private progressBar: HTMLDivElement;
  private progressFill: HTMLDivElement;
  private statusText: HTMLDivElement;

  constructor() {
    // Overlay
    this.overlay = document.createElement('div');
    Object.assign(this.overlay.style, {
      position: 'fixed',
      inset: '0',
      zIndex: '9999',
      display: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      background: 'rgba(10, 10, 15, 0.95)',
      fontFamily: "'Segoe UI', system-ui, sans-serif",
    } satisfies Partial<CSSStyleDeclaration>);

    // Container for progress elements
    const container = document.createElement('div');
    Object.assign(container.style, {
      width: '360px',
      textAlign: 'center',
    } satisfies Partial<CSSStyleDeclaration>);

    // Title
    const title = document.createElement('div');
    title.textContent = 'Loading Skins';
    Object.assign(title.style, {
      color: '#ffffff',
      fontSize: '18px',
      fontWeight: '600',
      marginBottom: '20px',
      letterSpacing: '1px',
      textTransform: 'uppercase',
    } satisfies Partial<CSSStyleDeclaration>);

    // Progress bar track
    this.progressBar = document.createElement('div');
    Object.assign(this.progressBar.style, {
      width: '100%',
      height: '6px',
      borderRadius: '3px',
      background: '#1e1e2a',
      overflow: 'hidden',
    } satisfies Partial<CSSStyleDeclaration>);

    // Progress bar fill
    this.progressFill = document.createElement('div');
    Object.assign(this.progressFill.style, {
      width: '0%',
      height: '100%',
      borderRadius: '3px',
      background: 'linear-gradient(90deg, #00bfff, #7b2ffc)',
      transition: 'width 0.2s ease-out',
    } satisfies Partial<CSSStyleDeclaration>);
    this.progressBar.appendChild(this.progressFill);

    // Status text
    this.statusText = document.createElement('div');
    Object.assign(this.statusText.style, {
      color: '#888899',
      fontSize: '13px',
      marginTop: '12px',
      minHeight: '20px',
    } satisfies Partial<CSSStyleDeclaration>);

    container.appendChild(title);
    container.appendChild(this.progressBar);
    container.appendChild(this.statusText);
    this.overlay.appendChild(container);
    document.body.appendChild(this.overlay);
  }

  show(): void {
    this.progressFill.style.width = '0%';
    this.statusText.textContent = 'Preparing...';
    this.overlay.style.display = 'flex';
  }

  hide(): void {
    this.overlay.style.display = 'none';
  }

  updateProgress(loaded: number, total: number, currentAsset?: string): void {
    const pct = total > 0 ? Math.round((loaded / total) * 100) : 0;
    this.progressFill.style.width = `${pct}%`;

    if (currentAsset) {
      this.statusText.textContent = `Loading ${currentAsset} (${loaded}/${total})`;
    } else {
      this.statusText.textContent = `${loaded} / ${total} skins loaded`;
    }
  }

  dispose(): void {
    this.overlay.remove();
  }
}
